<app-mainscreen>
  <app-simple-page-heading [breadcrumbs]="['Dashboard > Distributors']" title="Distributors" ></app-simple-page-heading>
<div style="height: 30px;"></div>
  <app-table-view
  [visibleColumnData] = "visibleColumnData"
  [visibleColumnsId] = "visibleColumnsId"
  [graphdata]="graphdata"
  [graphHeader]="graphHeader"
  title="Distributors"
  tableBackground="var(--grey3)"
  buttonTitle="Create Distributor"
  [showIconButtonEnd]="true"
  [showPaginator]="true"  
  (onActionClick)="onActionClick($event)"
  (onCreateBtnClick)="onCreateBtnClick($event)"
  [canCreate]="canCreate"
  [canView]="canView"
  [canDelete]="canDelete"
  [canEdit]="canEdit"
  [canEditPermission]="canEditPermission"
  [PermissionDesc]="'Edit Product Permission'"
  [showLoader]="showLoader"
></app-table-view>
<app-stepper-dialog></app-stepper-dialog>
</app-mainscreen>

<div class="overlay" *ngIf="showPermissionPopup">
  <div class="popup2 position-relative col-md-4">
    <div class="modal-header tooltip_ py-1 text-white">
      <h3>Insurance Product Permission</h3>
      <button type="button" class="close pull-right svg_white" aria-label="Close"  (click)="this.showPermissionPopup = false;">
        <span aria-hidden="true"></span>
     </button>
    </div>
    <div class="modal-body min-h-330 p-0">       
      <div class="col-9 position-relative" >
        <label class="box_title_18 w-100 mb-0 pb-2 mb-2"></label>
        <div class="">
            <app-multi-dropdown class="w-100 multiselect_custom input_" [items]="productList"
                [showSearch]="true" [showAll]="true" [showStatus]="false"
                (itemChange)="onMultiSelectChange($event)" 
                placeholder=" " id="Product">
            </app-multi-dropdown>
            <label class="float-start required label_ms">Product</label>
        </div>
      </div>
      <div class="col-3 offset-sm-9 text-right position-absolute bottom-15">
        <app-custom-button text="Submit" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="SaveUpdateUserProductPermission()">
        </app-custom-button>
      </div>
    </div>
  </div>
</div>